import React, {useState, useEffect, useRef,useMemo} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic ,Select  } from 'antd';
import { transfer,transferBnb,balanceOf,signer,balanceOfBNB } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getAirIndex,addAir} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';

const nowTime = Date.parse(new Date()) / 1000
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;




    function CircleProgress({ value = 95 }) {
  const radius = 46;
  const stroke = 8;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="relative w-[112px] h-[112px] flex items-center justify-center text-xs">
      <svg width="112" height="112" className="rotate-[-90deg] ">
        <circle
          stroke="#d2cbc3"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx="56"
          cy="56"
        />
        <circle
          stroke="#ff7a12"
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          r={normalizedRadius}
          cx="56"
          cy="56"
        />
      </svg>
      <div className="absolute text-[#141414] text-[16px] font-semibold">
        {value}%
      </div>
    </div>
  );
}

function CountdownBox({ value }) {
  return (
    <div className="w-[48px] h-[40px] rounded-[9px] bg-[#1c1c1d] border border-[#626262] shadow-[inset_0_1px_6px_rgba(255,255,255,0.12)] flex items-center justify-center text-white text-[17px] font-semibold">
      {value}
    </div>
  );
}


const Air = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [list1,setList1] = useState([])
    const [mintPrice,setMintPrice] = useState(0)
    const [mintBnb,setMintBnb] = useState(0)
    const [levelJie,setLevelJie] = useState(0)
    const [receiveAddress,setReceiveAddress] = useState("")
    const [receiveJieAddress,setReceiveJieAddress] = useState("")
 const [isLock,setIsLock]=useState(false)
const [balanceUsdt,setBalanceUsdt]=useState(null)
 const [needUsdt,setNeedUsdt] = useState(10000)

    const [mints,setMints] = useState("")
 
    const [pm,setPm] = useState(0)
    const [bnb,setBnb] = useState(0.1)

    const [minted,setMinted] = useState(0)
    const [maxMint,setMaxMint] = useState(0)
 const [tab,setTab] = useState(1)
    const [per,setPer] = useState(0)
    const [isOpen,setIsOpen] = useState(true)
    const [showMint,setShowMint] = useState(true)
    const ref = useRef()

    const [nodeIndex , setNodeIndex] = useState(2)
    const [balanceBnb,setBalanceBnb] = useState(0)
    const [has,setHas] = useState(false)

     const [ended, setEnded] = useState(false);

     const endTime = new Date("2026-09-01 00:00:00").getTime();

     const [left,setLeft] = useState(0)
     
     const [yi,setYi] = useState(0)

    const [countdown, setCountdown] = useState({
    day: "000",
    hour: "00",
    minute: "00",
    second: "00",
    });

  const activity = {
    token: "HSBC",
    totalRewardText: "千万美金红包计划",
    percent: 95,
    claimed: 224,
    remaining: 0,
    minBalance: "0.002",
    endCountdown: {
      day: "424",
      hour: "21",
      minute: "07",
      second: "30",
    },
  };

  const canClaim = useMemo(() => {
    return !ended && activity.remaining > 0;
  }, [ended, activity.remaining]);

   const handleClaim = async () => {
    if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
    }
    if(props.isLogin === false){
        // message.error(t('mint.请先绑定推荐地址!'))
        props.setFlash(true)
        return false
    }

    if(parseFloat(balanceBnb)< 0.002){
        message.error(t('air.地址必须有0.002BNB,才有资格'))
        return
    }

    if(isLock) return false;
    setIsLock(true)
    signer(props.address).then(res=>{
        addAir({address:props.address,receive:props.address,pass:res.pass}).then(res=>{
            if(res.code===0){
                message.success(t('air.领取成功'))
            }else{
                message.error(res.msg)
            }
            setIsLock(false)
            
            setNum(num+1)
        },error=>{
            setIsLock(false)
            message.error(res.msg)
        })

    },error=>{
        setIsLock(false)
    })

    // 这里接你的钱包领取逻辑
    // 1. 检查钱包是否连接
    // 2. 检查用户 HSBC 余额是否 >= 0.02
    // 3. 请求后端领取签名 / 领取资格
    // 4. 调用合约 claim 或后端发放奖励

    console.log("claim airdrop");
  };

  const _balanceOf = () =>{
          
          if(props.address.length<=0 || !props.isLogin) return false
        
          balanceOfBNB(props.address).then(res=>{
              
              setBalanceBnb(res)
          })
  
      }

  const _getTuanInfo = () =>{
          if(props.address.length>0 && props.isLogin){
              getAirIndex().then(res=>{
                  if(res.code == 0){
                    setPer(res.data.per)
                    setLeft(res.data.left)
                    setYi(res.data.yi)
                    setHas(res.data.has)
                  //     setReceiveAddress(res.data.receive)
                  //     setReceiveJieAddress(res.data.receive1)
                  //     setLevelJie(res.data.levelJie)
                  //    setMintPrice(res.data.price)
                  //     setMintBnb(res.data.eth)
                  //     setMaxMint(res.data.total)
                  //     setMinted(res.data.minted)
                  //     setPer(res.data.per)
                //   setBalanceUsdt(res.data.usdt)
                    setList(res.data.list || [])
                //     setList1(res.data.list1 || [])
                    
                      
                  }else{
                      message.error(res.msg)
                  }
                 console.log(res)
              })
          }
      }

  useEffect(() => {
    props.setIsTiao(true)
    _getTuanInfo()
    _balanceOf()
  const timer = setInterval(() => {
    const now = Date.now();
    const diff = endTime - now;

    if (diff <= 0) {
      clearInterval(timer);
      setEnded(true);
      setCountdown({
        day: "000",
        hour: "00",
        minute: "00",
        second: "00",
      });
      return;
    }

    const day = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hour = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minute = Math.floor((diff / (1000 * 60)) % 60);
    const second = Math.floor((diff / 1000) % 60);

    setCountdown({
      day: String(day).padStart(2, "0"),
      hour: String(hour).padStart(2, "0"),
      minute: String(minute).padStart(2, "0"),
      second: String(second).padStart(2, "0"),
    });
  }, 1000);

  return () => clearInterval(timer);
}, [props.isLogin,num]);

   

  

    return (
        <>
            <Head/>
     
           
                      {/* <div className=' bg-[#F1F5F9] w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'></div>    */}
            
            <div className="min-h-screen pt-16 bg-[#081020] text-white px-4 pb-8 font-sans">
      <div className="max-w-[430px] mx-auto pt-6">
        <img alt='rr' className='' src={require('../../assets/bcb/airbg.jpg')} style={{"width":"100%"}}></img>
        {/* 顶部活动图 */}
       

        {/* 活动进度 */}
        <section className="mt-6 rounded-[14px] bg-[#102348] px-5 py-5 shadow-[0_10px_30px_rgba(0,0,0,0.18)]">
          <h2 className="text-[#e7c15d] text-[20px] font-semibold">
            {t('air.活动进度')}
          </h2>

          <p className="mt-3 text-[#e7c15d] text-[15px] leading-[24px]">
            {t('air.万物')}{activity.token}
            <br />
            {t('air.每个HSBC上线')}
          </p>

          <div className="mt-6 bg-[#fff4ea] rounded-[14px] px-4 py-4 flex items-center ">
            <CircleProgress value={per} />

            <div className="ml-7 text-[15px]">
              <div className="text-[#202020] leading-[24px]">
                {t('air.已领取')}：
                <div className="text-[#2f74c9] text-[16px]">
                  <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={yi}
                        prefix=""
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={false}
                        decimalScale={0} />{t('air.份')}
                </div>
              </div>

              <div className="mt-4 text-[#df2f1f] text-[16px]">
                {t('air.剩余')}：
                <span className="ml-4"><NumberFormat
                    thousandsGroupStyle="thousand"
                    value={left}
                    prefix=""
                    decimalSeparator="."
                    displayType="text"
                    type="text"
                    thousandSeparator={true}
                    allowNegative={false}
                    decimalScale={0} />{t('air.份')}</span>
              </div>
            </div>
          </div>

          <div className="mt-5 flex flex-col items-center">
            <div className="w-full text-center text-[#e7c15d] text-[18px] leading-[22px]">
              {t('air.距活动结束')}：
            </div>

            <div className="flex items-center gap-2 mt-3">
             <CountdownBox value={countdown.day} />
              <span className="text-[#e7c15d] text-[22px] leading-none">:</span>
              <CountdownBox value={countdown.hour} />
              <span className="text-[#e7c15d] text-[22px] leading-none">:</span>
              <CountdownBox value={countdown.minute} />
              <span className="text-[#e7c15d] text-[22px] leading-none">:</span>
              <CountdownBox value={countdown.second} />
            </div>
          </div>
        </section>

        {/* 参与活动 */}
        <section className="mt-4 rounded-[14px] bg-[#102348] px-5 py-5 shadow-[0_10px_30px_rgba(0,0,0,0.18)]">
          <h2 className="text-[#e7c15d] text-[20px] font-semibold">
            {t('air.参与活动')}
          </h2>
        {
            has?(
                <button
            
            
            className="mt-5 w-full h-[48px] rounded-[5px] text-[17px] font-medium transition-all bg-gradient-to-r from-gray-400 to-gray-600 text-white shadow-[0_8px_22px_rgba(255,92,32,0.35)] active:scale-[0.98]">
            {t('air.已领取')}
          </button>
            ):(
                <button
            onClick={handleClaim}
            
            className="mt-5 w-full h-[48px] rounded-[5px] text-[17px] font-medium transition-all bg-gradient-to-r from-[#ff7a18] to-[#e83b21] text-white shadow-[0_8px_22px_rgba(255,92,32,0.35)] active:scale-[0.98]">
           {t('air.立即领取空投')}
          </button>
            )
        }
          

          {!ended && (
            <p className="mt-3 text-center text-[12px] text-white/50">
              {t('air.领取前需持有不少于0.002个BNB')}
            </p>
          )}
        </section>

        {/* 实时领取记录 */}
        <section className="mt-4 rounded-[14px] bg-[#102348] px-5 py-5 shadow-[0_10px_30px_rgba(0,0,0,0.18)]">
          <h2 className="text-[#e7c15d] text-[20px] font-semibold">
            {t('air.实时领取记录')}
          </h2>

          <div className="mt-6 bg-white overflow-hidden">

             {
                list.length>0?
                    list.map((item,index)=> {
                        return (
                            <>
                               <div
                                    key={index}
                                    className="h-[62px] px-4 flex items-center justify-between border-b border-[#eeeeee] last:border-b-0"
                                >
                                    <div className="w-[34%]">
                                    <div className="text-[#1aa883] text-[13px] font-semibold">
                                        {t('air.领取')}
                                        {/* <span className="ml-2">{item.amount}</span> */}
                                    </div>
                                    <div className="mt-1 text-[#999] text-[13px]">
                                        {item.add_time}
                                    </div>
                                    </div>

                                    <div className="w-[28%] text-left">
                                    <div className="text-[#333] text-[13px]">
                                        <NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={item.value}
                                            prefix=""
                                            decimalSeparator="."
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={2} /> HSBC
                                    </div>
                                    <div className="mt-1 text-[#999] text-[13px]">
                                        $<NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={item.value*2}
                                            prefix=""
                                            decimalSeparator="."
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={2} />
                                    </div>
                                    </div>

                                    <div className="w-[34%] text-right">
                                    <div className="text-[#777] text-[13px]">{item.address}</div>
                                    <div className="mt-1 text-[#bbb] text-[12px]">◒ ✎</div>
                                    </div>
                                </div>
                            </>
                        )
                    }):(
                        <div  className=' w-full  py-32 flex flex-row items-center justify-center text-gray-400 text-xs'>
                            No data
                        </div>
                    )
            }
           
          </div>
        </section>

        {/* 规则说明 */}
        <section className="mt-5 rounded-[14px] bg-[#102348] px-5 py-5 shadow-[0_10px_30px_rgba(0,0,0,0.18)]">
          <h2 className="text-[#e7c15d] text-[20px] font-semibold">
            {t('air.活动规则说明')}
          </h2>

          <div className="mt-4 text-white text-[15px] leading-[28px]">
            <p>1、{t('air.说明1')}。</p>
            <p>2、{t('air.说明2')}</p>
            <p>3、{t('air.说明3')}</p>
          </div>
        </section>
      </div>
    </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        },
        setIsTiao(value){
            const action ={type:"setIsTiao",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Air);
